/* EXC footer: link columns as accordions on a phone only, and the Follow on
   Shop button shown as a Shop icon.
   The columns are the theme's own <details> accordions (accordion-group.js),
   rendered open. On a phone they start closed and open with the theme's plus
   and height animation. On desktop they stay open, and non-dismissible (the
   theme accordion's own switch) means a click on the heading does nothing.
   Breakpoint matches the theme's mobile media query, 47.9275em.
   Notes: hq/projects/excdesigns/theme-build-notes.md */
(function () {
  var phone = window.matchMedia('(max-width: 47.9275em)');

  function apply() {
    var items = document.querySelectorAll('#footer details.exc-footer-acc');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (phone.matches) {
        el.removeAttribute('non-dismissible');
        el.open = false;
      } else {
        el.setAttribute('non-dismissible', '');
        el.open = true;
      }
    }
  }

  /* Follow on Shop as a plain Shop icon.
     The button is Shopify's <shop-follow-button>, which draws itself inside
     its own shadow DOM with no styling hooks, so page CSS cannot reach it.
     A small stylesheet goes inside that shadow root instead: the purple fill,
     the heart and the words "Follow on" are hidden, and the white Shop logo is
     left at the size of the Instagram and TikTok icons. It is still Shopify's
     button, so following the store works exactly as before, and its label
     still reads "Follow on Shop" to screen readers.
     If Shopify changes the button's insides, these rules stop matching and the
     stock purple button shows again rather than something broken. */
  var SHOP_CSS =
    '.bg-purple-primary{display:none!important}' +
    'button{height:39px!important;padding:0 11px!important;background:transparent!important}' +
    'button>div:not(.bg-purple-primary){display:none!important}' +
    'button>span{font-size:0!important;line-height:0!important;padding:0!important;color:#fff!important;display:inline-flex!important;align-items:center}' +
    'button>span svg{height:15px!important;width:auto!important;top:0!important;color:#fff!important}' +
    'button:hover>span{opacity:.75}' +
    'button:focus-visible{outline:2px solid #fff;outline-offset:2px;border-radius:6px}';

  function styleShopButton(host) {
    if (host.hasAttribute('data-exc-styled')) return true;
    var root = host.shadowRoot;
    if (!root || !root.querySelector('button')) return false;
    var style = document.createElement('style');
    style.textContent = SHOP_CSS;
    root.appendChild(style);
    host.setAttribute('data-exc-styled', '');
    return true;
  }

  function watchShopButtons() {
    var hosts = document.querySelectorAll('#footer shop-follow-button');
    Array.prototype.forEach.call(hosts, function (host) {
      if (styleShopButton(host)) return;
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        // Give up after 10 seconds and show whatever Shopify rendered
        if (styleShopButton(host) || tries > 50) {
          clearInterval(timer);
          host.setAttribute('data-exc-styled', '');
        }
      }, 200);
    });
  }

  watchShopButtons();
  document.addEventListener('shopify:section:load', watchShopButtons);

  apply();
  if (phone.addEventListener) {
    phone.addEventListener('change', apply);
  } else if (phone.addListener) {
    phone.addListener(apply);
  }
  // The theme editor re-renders the footer section in place
  document.addEventListener('shopify:section:load', apply);
})();
